/* eslint-disable */
import './reviews.scss';
import Vue from 'vue';
import StaticCommentsView from '@fr/pages/desktop/application/hotel/index/staticComments/StaticComments';
import { HotelReviews, getHotelReviews, MAX_SIZE_REVIEWS } from '@widgets/hotelReviews';
import getTopHOtelsAvailable from '@/js/common/services/getTopHOtelsAvailable';
import noReviewTopHotelsTemplate from './noReviewTopHotels.html';

class HotelPageReviewsView extends Backbone.Epoxy.View {
    initialize() {
        this.topHotelsLoaded = false;
        this.travelataLoaded = false;
        this.$loader = $('#reviews_tophotels .tophotelsLoader');
        this.$reviewsTabs = $('#reviewsTabs');
        this.$tophotelsFrame = $('#reviews_tophotels .frame');
        this.ourReviews = new StaticCommentsView({
            el: '#reviews_our',
        });
        this.isTopHotelAvailvable = getTopHOtelsAvailable();
        this.initDOMEvents();
        this.initDefaultActiveTabs();
        this.deleteTopHotels();
        this.getTripAdviserHotelReviews();
    }

    deleteTopHotels() {
        if (this.isTopHotelAvailvable) {
            return;
        }


        const topHotelsLogo = document.querySelector('.tophotelsLogo')?.closest('li');
        const topHotelsContainer = document.querySelector('#reviews_tophotels');

        if (topHotelsLogo && topHotelsContainer) {
            topHotelsLogo.style.display = 'none';
            topHotelsContainer.style.display = 'none';
        }

        this.$reviewsTabs.tabs({ active: 1 });//travelata active tabs
        this.$reviewsTabs.trigger('tabsactivate');
    }

    async getTripAdviserHotelReviews() {
        const res = await getHotelReviews({ limit: MAX_SIZE_REVIEWS * 2, hotelId: window.appConfig.hotelInfo?.id, page: 1 });
        this.tripAdviserData = res;
        if(!res.reviews?.length) this.$reviewsTabs.find("li").eq(2).hide();
    }

    initDOMEvents() {
        this.$reviewsTabs.on('tabsactivate', async () => {
            const activeTab = this.$reviewsTabs.tabs('option', 'active') ? 'travelata' : 'topHotels';

            if (activeTab === 'topHotels' && !this.topHotelsLoaded && this.isTopHotelAvailvable) {
                this.getTopHotelsScript()
                .then((tophotelsScript) => {
                    this.$tophotelsFrame.html(tophotelsScript);
                    this.topHotelsLoaded = true;
                })
                .catch((noReviewsTemplate) => {
                    $('#reviews_tophotels').html(noReviewsTemplate);
                });
            } if ((activeTab === 'travelata' && !this.travelataLoaded) || !this.isTopHotelAvailvable) {
                this.ourReviews.loadData()
                .then(() => {
                    this.travelataLoaded = true;
                });
            }
        });

        this.$reviewsTabs.on('tabsactivate', (data) => {
            if(this.$reviewsTabs.tabs('option', 'active') === 2) {
                new Vue({
                    render: (h) => h(HotelReviews, {
                        props: {
                            hotelId: window.appConfig.hotelInfo?.id,
                            initialHotelReview: this.tripAdviserData, 
                        }
                    }),
                }).$mount('.js-block-tripadviser');
            }
        })
    }

    getTopHotelsScript() {
        return new Promise((res, rej) => {
            const getReviewsURL = `${window?.appConfig?.gatewayUrl}/apiV1/hotel/getTopHotelsReviews?id=${window?.appConfig?.hotelInfo?.id}`;
            jQuery.ajax({
                url: getReviewsURL,
                type: 'POST',
            })
            .done((response) => {
                const result = response?.data;
                if (response?.success === true && result) {
                    res(result);
                    return;
                }
                this.$reviewsTabs.tabs('disable', 0);
                rej(noReviewTopHotelsTemplate);
            })
            .always(() => {
                this.$loader.hide();
            });
        });
    }

    initDefaultActiveTabs() {
        const reviewsSource = window.appConfig.hotelInfo?.reviewsSource;
        const allReviews = {
            topHotels: { active: 0 },
            travelata: { active: 1 },
        };

        this.$reviewsTabs.tabs(allReviews[reviewsSource]);
        this.$reviewsTabs.trigger('tabsactivate');
    }
}

export default HotelPageReviewsView;
